import React, { Component } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ScrollLock from "react-scrolllock";
import Image from "./Image";
import Button from "./Button";

const shareIcon = require("../assets/images/ic_share.svg");
const closeIcon = require("../assets/images/ic_close.svg");
const facebookIcon = require("../assets/images/ic_facebook_colour.svg");
const linkedInIcon = require("../assets/images/ic_linkedin_colour.svg");
const twitterIcon = require("../assets/images/ic_twitter_colour.svg");
const copyIcon = require("../assets/images/ic_copy_link.svg");

class Share extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      copied: false
    };
    this.shareClicked = this.shareClicked.bind(this);
    this.closeClicked = this.closeClicked.bind(this);
    this.killClick = this.killClick.bind(this);
  }

  killClick(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }

  shareClicked(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.setState({
      open: true
    });
  }

  closeClicked(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.setState({
      open: false
    });
  }

  render() {
    const { open, copied } = this.state;
    const { iconPosition, eventLink, icon = true } = this.props;

    let textPosition = copied ? "385px" : "404px";
    return (
      <div style={iconPosition}>
        {icon ? (
          <button onClick={this.shareClicked}>
            <Image src={shareIcon} alt="Share Icon" />
          </button>
        ) : (
          <Button type="primary" onClick={this.shareClicked}>
            Share
          </Button>
        )}
        {open ? (
          <div className="fadeDiv" onClick={this.killClick}>
            <ScrollLock />
            <div
              className="shareWrapper"
              style={
                window.innerWidth < 820 ? { top: window.innerHeight - 165 } : {}
              }
            >
              <div className="shareHeading">
                <h2 className="heading">Share Event</h2>
                <button
                  className="closeButton"
                  onClick={this.closeClicked}
                  aria-label="Close button"
                >
                  <Image src={closeIcon} alt="Close Icon" />
                </button>
              </div>
              <div className="shareBody">
                <div className="iconWrapper">
                  <div className="copyBubble">
                    <CopyToClipboard text={eventLink}>
                      <button
                        className="buttonSocial"
                        aria-label="Copy Button"
                        aria-hidden={true}
                      >
                        <Image
                          className="shareLogo"
                          src={copyIcon}
                          alt="Copy Button"
                        />
                      </button>
                    </CopyToClipboard>
                  </div>
                  <button
                    className="buttonSocial"
                    onClick={() =>
                      window.open(
                        `http://www.facebook.com/sharer.php?u=${eventLink}`,
                        "_blank"
                      )
                    }
                    aria-label="Share - Facebook"
                  >
                    <Image
                      className="shareLogo"
                      src={facebookIcon}
                      alt="Facebook Icon"
                    />
                  </button>
                  <button
                    className="buttonSocial"
                    onClick={() =>
                      window.open(
                        `https://twitter.com/share?url=${eventLink}&amp;hashtags=humanitix`,
                        "_blank"
                      )
                    }
                    aria-label="Share - Twitter"
                  >
                    <Image
                      className="shareLogo"
                      src={twitterIcon}
                      alt="Twitter Icon"
                    />
                  </button>
                  <button
                    className="buttonSocial"
                    onClick={() =>
                      window.open(
                        `https://www.linkedin.com/sharing/share-offsite/?url=${eventLink}`,
                        "_blank"
                      )
                    }
                    aria-label="Share - Linked In"
                  >
                    <Image
                      className="shareLogo"
                      src={linkedInIcon}
                      alt="LinkedIn Icon"
                    />
                  </button>
                </div>
                <div className="copySection">
                  <input
                    className="linkBox"
                    type="text"
                    value={eventLink}
                    readonly
                  />
                  <CopyToClipboard
                    text={eventLink}
                    onCopy={() => this.setState({ copied: true })}
                  >
                    <button
                      className="copyButton"
                      style={{
                        left: `${textPosition}`,
                        color: copied ? "#5A626C" : "#6621c0"
                      }}
                      aria-label="Copy Button"
                      aria-hidden={true}
                    >
                      {copied ? "Copied" : "Copy"}
                    </button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default Share;



// WEBPACK FOOTER //
// ./components/Share.js